// ==== Arcade rewards: shared login + points-claim handling for every game ====
// Include this once, after jQuery, anywhere before the games are used.
// Each game just calls: ArcadeRewards.reportComplete('gameId', score)

window.ArcadeRewards = (function () {
  // Placeholder numbers — tune these once you've seen real score ranges from playtesting.
  const MIN_SCORE = { carrom: 20, checkers: 10, ludo: 30, scrabble: 15 };
  const POINTS_PER_DOLLAR = { carrom: 100, checkers: 60, ludo: 150, scrabble: 120 };
  const CLAIM_ENDPOINT = '/apps/arcade';//'//technology-architects.com/tasweer-modules/gamingModule/claim.php'; // Shopify App Proxy path — see note in chat
  const STORAGE_KEY = 'arcadePendingClaim';
  const STALE_AFTER_MS = 30 * 60 * 1000; // ignore a pending claim older than 30 min

  let overlay, titleEl, subEl, btnEl;

  function ensureOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.id = 'arcade-claim-overlay';
    overlay.innerHTML =
      '<div id="arcade-claim-card">' +
      '<div id="arcade-claim-title"></div>' +
      '<div id="arcade-claim-sub"></div>' +
      '<button id="arcade-claim-btn"></button>' +
      '</div>';
    document.body.appendChild(overlay);
    titleEl = document.getElementById('arcade-claim-title');
    subEl = document.getElementById('arcade-claim-sub');
    btnEl = document.getElementById('arcade-claim-btn');

    const style = document.createElement('style');
    style.textContent =
      '#arcade-claim-overlay{position:fixed;inset:0;background:rgba(0,0,0,.7);display:flex;' +
      'align-items:center;justify-content:center;z-index:9999;padding:20px;}' +
      '#arcade-claim-card{background:#1e1e1e;color:#fff;padding:28px;border-radius:12px;' +
      'max-width:320px;width:100%;text-align:center;display:flex;flex-direction:column;gap:14px;' +
      'font-family:inherit;}' +
      '#arcade-claim-title{font-size:1.3rem;font-weight:bold;}' +
      '#arcade-claim-sub{font-size:.9rem;color:#aaa;}' +
      '#arcade-claim-btn{padding:12px 20px;border:none;border-radius:6px;font-weight:bold;' +
      'cursor:pointer;background:#2e7d32;color:#fff;font-size:1rem;}' +
      '#arcade-claim-btn:disabled{background:#444;color:#888;cursor:not-allowed;}';
    document.head.appendChild(style);
  }

  function show(opts) {
    ensureOverlay();
    titleEl.textContent = opts.title;
    subEl.textContent = opts.sub;
    btnEl.textContent = opts.btnText;
    btnEl.disabled = !!opts.btnDisabled;
    btnEl.onclick = opts.btnAction || null;
    overlay.style.display = 'flex';
  }

  function hide() {
    if (overlay) overlay.style.display = 'none';
  }

  function dollarsFor(game, score) {
    return Math.floor((score / POINTS_PER_DOLLAR[game]) * 100) / 100;
  }

  function startLoginRedirect(pending) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = '/account/login?return_url=' + returnUrl;
  }

  function submitClaim(pending) {
    show({ title: 'Claiming your credit…', sub: 'Just a moment.', btnText: 'Please wait…', btnDisabled: true });

    fetch(CLAIM_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(pending)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('claim failed');
        return res.json();
      })
      .then(function (data) {
        sessionStorage.removeItem(STORAGE_KEY);
        show({
          title: 'Credit added!',
          sub: data && data.amount ? ('$' + data.amount + ' store credit is on your account.') : 'Your store credit is on its way.',
          btnText: 'Keep playing',
          btnAction: hide
        });
      })
      .catch(function () {
        show({
          title: 'Something went wrong',
          sub: 'Your score is saved — try claiming again.',
          btnText: 'Try again',
          btnAction: function () { submitClaim(pending); }
        });
      });
  }

  function reportComplete(gameId, score) {
    const min = MIN_SCORE[gameId] || 0;
    if (typeof score !== 'number' || score < min) return;

    const pending = { game: gameId, score: score, claimedAt: Date.now() };

    if (!window.__arcadeCustomer || !window.__arcadeCustomer.loggedIn) {
      show({
        title: 'You scored ' + score + '!',
        sub: 'Log in to convert it to ~$' + dollarsFor(gameId, score) + ' store credit.',
        btnText: 'Log in to claim',
        btnAction: function () { startLoginRedirect(pending); }
      });
    } else {
      submitClaim(pending);
    }
  }

  // Coming back from a login redirect with a claim still waiting?
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.__arcadeCustomer || !window.__arcadeCustomer.loggedIn) return;
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    try {
      const pending = JSON.parse(raw);
      if (Date.now() - pending.claimedAt > STALE_AFTER_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      submitClaim(pending);
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  });

  return { reportComplete: reportComplete };
})();
